import { StatusBadge } from './StatusBadge';

type ActiveStatusBadgeProps = {
  active: boolean;
  /** Usa Ativa/Inativa em vez de Ativo/Inativo. */
  feminine?: boolean;
  activeLabel?: string;
  inactiveLabel?: string;
  className?: string;
};

export function ActiveStatusBadge({
  active,
  feminine = false,
  activeLabel,
  inactiveLabel,
  className,
}: ActiveStatusBadgeProps) {
  const label = active
    ? (activeLabel ?? (feminine ? 'Ativa' : 'Ativo'))
    : (inactiveLabel ?? (feminine ? 'Inativa' : 'Inativo'));

  return (
    <StatusBadge tone={active ? 'success' : 'neutral'} className={className}>
      {label}
    </StatusBadge>
  );
}
